<template>
  <div class="TriggerSet">
    <el-form ref="form" label-width="120px">
      <el-row>
        <el-col :span="8">
          <el-form-item label="触发器Sql类型">
            <el-select v-model="sqlType" placeholder="请选择">
              <el-option label="添加sql" :value="1" ></el-option>
              <el-option label="修改sql" :value="2" ></el-option>
              <el-option label="删除sql" :value="3" ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="触发条件">
            <TjPlug :tableId="tableId" :sourceType="0" v-model="sourceTjPlugInfo" :ifSavePlug="true" ></TjPlug>
          </el-form-item>
        </el-col>
       <!-- 添加时才有是否递归 -->
        <el-col :span="8" v-if="sqlType == 1">
          <el-form-item label="是否递归">
            <el-select v-model="ifDg" placeholder="请选择">
              <el-option label="否" value="0" ></el-option>
              <el-option label="是" value="1" ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="目标对象">
            <el-select v-model="goalTableObject" filterable reserve-keyword placeholder="请输入关键词"  :loading="tableObjectloading"  value-key="tableId"  @change="tableObjectChange(goalTableObject)" >
              <!-- remote :remote-method="(query)=>loadTableObject(1,query)" -->
              <el-option
                v-for="goalTableOne in goalObjectArr"
                :key="goalTableOne.tableId"
                :label="goalTableOne.tableCnName"
                :value="goalTableOne" >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        
        <!-- 添加时才有源对象 修改时没有源对象 -->
        <el-col :span="8" v-if="sqlType == 1">
          <el-form-item label="源对象">
            <!-- <el-select v-model="triggerOne.sourceTableObject" filterable remote reserve-keyword placeholder="请输入关键词" :remote-method="(query)=>loadTableObject(triggerOne,2,query)" :loading="tableObjectloading" @change="(chooseTable)=>tableObjectChange(triggerOne,2,chooseTable)" value-key="tableId" >
              <el-option
                v-for="sourceTableOne in triggerOne.sourceObjectArr"
                :key="sourceTableOne.tableId"
                :label="sourceTableOne.tableCnName"
                :value="sourceTableOne" >
              </el-option>
            </el-select> -->
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="goalTableObject.tableId > 0 && goalTableObject.tableId != tableId">
          <el-form-item label="关联条件" >
            <TjPlug :tableId="goalTableObject.tableId+''" :xnTableId="tableId"  :sourceType="0" v-model="goalTjPlugInfo" :ifSavePlug="true"></TjPlug>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 目标对象字段信息 -->
      <template v-for="(goalFieldOne,index) in goalTableObject.goalFieldArr">
        <el-row  :key="index" style="border: 1px solid;">
          <el-col :span="8" >
            {{goalFieldOne.fieldCnName}}
          </el-col>
          <el-col :span="8" >
            <el-select v-model="goalFieldOne.fieldValueType" placeholder="请选择"  style="width:120px;" @change="fieldValueTypeChange" >
              <el-option label="触发对象" value="1" ></el-option>
              <el-option label="目标对象" value="2" v-if="goalTableObject.tableId > 0 && goalTableObject.tableId != tableId"></el-option>
              <el-option label="数据字典" value="3" ></el-option>
            </el-select>
            
          </el-col>
          <el-col :span="8" >
            <ValuePlug v-if="goalFieldOne.fieldValueType == 1 || goalFieldOne.fieldValueType == 2" :tableId="goalFieldOne.fieldValueType == 1?(tableId+''):(goalTableObject.tableId+'')" v-model="goalFieldOne.valuePlugInfo" :sourceType="0" :ifSavePlug="true"></ValuePlug>
            <el-select v-else-if="goalFieldOne.fieldValueType == 3" v-model="goalFieldOne.fieldChooseDicId" placeholder="请选择">
              <el-option v-for="(dicItem,dicIndex) in goalFieldOne.dicList" :key="dicIndex" :label="dicItem.DIC_NAME" :value="dicItem.DIC_ID"></el-option>
            </el-select>
          </el-col>
        </el-row>
      </template>
      <el-row>
        <el-col :span="24">
          <el-form-item label="sql">
            <el-button @click="toAppendSql()">生成sql</el-button>
            <el-input type="textarea" placeholder="拼接的sql语句" v-model="zdySql">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';
import ValuePlug from '@/components/page/pageUtil/ValuePlug.vue';
import TjPlug from '@/components/page/pageUtil/TjPlug.vue';
export default {
  name: 'TriggerSet',
  props: {
    
  },
  data() {
    return {
      tableId:0,
      sqlType:2,
      zdySql:"",
      ifDg:0,
      tableObjectloading:false,
      //触发对象的条件插件信息
      sourceTjPlugInfo:{
        nameStr:"",
        resultStr:"",
        tjPlugId:0
      },
      //目标对象的条件插件信息
      goalTjPlugInfo:{
        nameStr:"",
        resultStr:"",
        tjPlugId:0
      },
      //目标对象
      goalObjectArr:[],
      //目标对象的选中值
      goalTableObject:{
        goalFieldArr:[]
      },
      //源对象
      sourceObjectArr:[]
    };
  },
  created() {
    var paramsJson = this.$route.query;
    this.tableId = paramsJson.tableId;
    this.loadTableObject(1,"");
  },
  mounted() {
    
  },
  watch:{
  },
  computed:{
  },
  components: {
    ValuePlug,
    TjPlug
  },
  methods: {
    /**
     * 加载对象弹出层信息 
     */
    loadTableObject:function(type,query){
      console.log("query================",query);
      var that = this;
      var url = "dialog_getAllTableInfo.do";
      var toHtData={};
      that.tableObjectloading = true;
      if (query !== '') {
        toHtData.tableCnNameSearch = query;
        toHtData.start = 0;
        toHtData.limit = "10000_flow";
        toHtData.ifAjaxCount = false;
      } else {
        toHtData.start = 0;
        toHtData.limit = "1000_flow";
        toHtData.ifAjaxCount = false;
      }
      utils.request(that,{
        url: url, 
        data: toHtData,
        success: function (res) {
          console.log(res.data);
          if(res.data) {
            if(type == 1) {
              that.goalObjectArr = res.data.rows;
              var goalTableObject = that.goalObjectArr.filter(function (value, index, array) {
                  return value.tableId == that.tableId;
              })[0];
              that.$set(goalTableObject,"goalFieldArr",[])
              that.goalTableObject = goalTableObject;
              that.loadFieldObject(that.goalTableObject);
            } else if(type == 2) {
              that.sourceObjectArr = res.data.rows;
            }
          }
          that.tableObjectloading = false;
        }
      })
    },
    /**
     * 对象选择切换时
     */
    tableObjectChange(tableObject){
      var that = this;
      if(!tableObject.goalFieldArr || tableObject.goalFieldArr.length == 0) {
        that.loadFieldObject(tableObject);
      }
    },
    fieldValueTypeChange(){
      // this.$forceUpdate();
      // this.toAppendSql();
    },

    /**
     * 加载字段信息 根据目标对象
     */
    loadFieldObject:function(tableObject){
      var that = this;
      var url = "plug_TriggerGetFieldInfoByTableId.do";
      var toHtData = {
        tableId:tableObject.tableId
      };
      toHtData.start = 0;
      toHtData.limit = "999_flow";
      toHtData.ifAjaxCount = true;
      utils.request(that,{
        url: url, 
        data: toHtData,
        success: function (res) {
          console.log(res.data);
          if(res.data) {
            var goalFieldArr = [];
            res.data.rows.forEach(element=>{
              if(typeof(element.dicJson) == "string") {
                element.dicList = JSON.parse(element.dicJson);
              }
              element.fieldValueType = "1";
              element.connectObjId = that.tableId;
              element.valuePlugInfo = {
                nameStr:"",
                resultStr:"",
                valuePlugId:0
              }
              goalFieldArr.push(element);
            })
            // tableObject.goalFieldArr = goalFieldArr;
            that.$set(tableObject,"goalFieldArr",goalFieldArr)
            console.log("tableObject====================",tableObject);
            that.$forceUpdate();
          }
        }
      })
    },
    /**
     * 去后台拼接触发器sql
     */
    toAppendSql:function(){
      var that = this;
      //获取选中的字段信息，传递到后台进行sql拼接
      var goalFieldArr =  that.goalTableObject.goalFieldArr;
      var valuePlugStrList = [];
      var valuePlugIdList = [];
      var targetValuePlugStrList = [];
      var targetValuePlugIdList = [];
      var valuePlugIndexMap = {};
      goalFieldArr.forEach((element,index) => {
        var fieldValueType = element.fieldValueType;
        if(element.valuePlugInfo && element.valuePlugInfo.resultStr != "") {
          if(fieldValueType == 1) {
            valuePlugStrList.push(element.valuePlugInfo.resultStr);
            valuePlugIdList.push(element.valuePlugInfo.valuePlugId);
            valuePlugIndexMap["goal_" + index] = valuePlugStrList.length;
          } else if(fieldValueType == 2) {
            targetValuePlugStrList.push(element.valuePlugInfo.resultStr);
            targetValuePlugIdList.push(element.valuePlugInfo.valuePlugId);
          }
        }
      });

      var url = "object_autoTriggerSql.do";
      var toHtData = {
        tableId:that.tableId
      };
      if(that.sourceTjPlugInfo.tjPlugId > 0) {
        toHtData.tjPlugId = that.sourceTjPlugInfo.tjPlugId;
        toHtData.tjTableId = that.tableId;
      }
      toHtData.valueIdArr = valuePlugIdList;
      console.log("valuePlugIdList================",valuePlugIdList);
      utils.request(that,{
        url: url, 
        data: toHtData,
        success: function (res) {
          console.log(res.data);
          if(res.data) {
            var selectSql = res.data;
            //判断修改表是否等于触发表 如果等于 直接把查询sql变更为修改sql  如果修改表不等于触发表 则update 拼接 查询sql 并拼接 join on条件 
            console.log("触发对象的查询sql========sql===========",selectSql);
            if(that.goalTableObject.tableId != that.tableId) {
              //目标表和触发表是一个页面
              var toHtData = {
                tableId:that.goalTableObject.tableId
              };
              if(that.goalTjPlugInfo.tjPlugId > 0) {
                toHtData.tjPlugId = that.goalTjPlugInfo.tjPlugId;
                toHtData.tjTableId = that.tableId;
              }
              toHtData.valueIdArr = targetValuePlugIdList;
              console.log("valuePlugIdList================",valuePlugIdList);
              utils.request(that,{
                url: url, 
                data: toHtData,
                success: function (resTarget) {
                  console.log(resTarget.data);
                  if(resTarget.data) {
                    var targetSelectSql = resTarget.data;
                    console.log("targetSelectSql===================",targetSelectSql);
                  }
                }
              })
            } else {
              //主表的表名和别名
              var mainTableNameAndAlias = selectSql.substring(selectSql.indexOf("from")+4,selectSql.indexOf("#{" + that.tableId + "_t}"))
              //连表的sql
              var leftJoinSql = selectSql.substring(selectSql.indexOf("#{" + that.tableId + "_t}")+("#{" + that.tableId + "_t}").length,selectSql.lastIndexOf(" where "));
              var whereSql = selectSql.substring(selectSql.lastIndexOf(" where "));
              //查询出的字段的显示列
              var selectFieldSql = selectSql.substring(6,selectSql.indexOf("#{" + that.tableId + "_f}"));
              var selectFieldSqlArr = selectFieldSql.split(/(AFM_[0-9]+[\s]+,)/g);

              var updateSql = "update " + mainTableNameAndAlias + leftJoinSql;
              updateSql += " set ATM_0.UPDATER =${USERID},ATM_0.UPDATE_DATE=NOW()";
              var xhIndex = 0;
              goalFieldArr.forEach((element,index) => {
                var fieldValueType = element.fieldValueType;
                if(element.valuePlugInfo && element.valuePlugInfo.resultStr != "") {
                  updateSql += " ,ATM_0." + element.fieldName + "=" + selectFieldSqlArr[xhIndex].trim();
                  xhIndex ++;
                  xhIndex ++;
                } else if(element.fieldChooseDicId) {
                  updateSql += " ,ATM_0." + element.fieldName + "=" + element.fieldChooseDicId;
                }
              });
              updateSql += whereSql;
              that.zdySql = updateSql;
            }
          }
        }
      })
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
